import React from "react";

const CardMedia = ({ cardInfo, tokens = [], cardsPerRow, onImageClick }) => (
  <div
    className="col-md card-modal-left d-flex align-items-center align-content-start justify-content-center flex-wrap"
    onClick={onImageClick}
  >
    <div
      className={`card-list ${
        tokens.length >= 2 ? `cards-per-row-${cardsPerRow}` : "cards-per-row-1"
      }`}
    >
      <div className="card-in-modal">
        <img
          src={`/cards/${cardInfo.cardId2}.${cardInfo.cardFormat}`}
          alt={cardInfo.cardName}
          className="img-fluid mb-3"
        />
      </div>

      {tokens.map((token) => (
        <div className="card-in-modal" key={token.id}>
          <img
            src={`/cards/${token.id}.${token.format}`}
            alt={token.class}
            className="img-fluid mb-3"
          />
        </div>
      ))}
    </div>
  </div>
);

export default CardMedia;
